import React from 'react';
import {CyClass} from "../../../../../../common/cy-classes";
import {PanicButtonBox} from "./boxes/panic-button.box";
import {PanicButtonTooltipBox} from "./boxes/panic-button-tooltip.box";
import classNames from 'classnames';
import {observer} from "mobx-react";
import {PanicButtonPopupComponent} from "./panic-button-popup.component";
import {TooltipClickHereBox} from "./boxes/panic-button-tooltip-click-here";
import {OrbitComponentWithState} from "../../../../base-components/orbit-component-with-state/orbit-component-with-state";
import {ACTIVE} from "../../../../../themes/css-global-classes";
import {IN_DETAILED_HISTORY} from "./css-classes";
import {GermanyResponsibleGamingButtonPlacement} from "../../../../../../common/const/responsible-gaming";
import {PanicButtonTooltipCloseBox} from "./boxes/panic-button-tooltip-close.box";
import {PanicButtonMobileOverlayBox} from "./boxes/panic-button-mobile-overlay.box";
import {Image} from '../../../../raw-components/image/image';

interface TooltipState {
    isTooltipVisible: boolean
}

export interface ResponsibleGamingButtonsGermanyComponentProps {
    placement: GermanyResponsibleGamingButtonPlacement
}

@observer
export class ResponsibleGamingButtonsGermanyComponent extends OrbitComponentWithState<ResponsibleGamingButtonsGermanyComponentProps, TooltipState> {
    state: TooltipState = {
        isTooltipVisible: false
    };

    componentDidMount() {
        super.componentDidMount();
        this.setState({
            isTooltipVisible: false
        })
    }

    private _restrictUser(): void {
        this.setState({isTooltipVisible: false});
        this.services.user.panicRestrictUser().then((data) => {
            console.log(data);
            this._openPopup();
        }).catch((err) => {
            console.log(err);
        });
        this._sendAnalytics("activate");
    }

        private _openPopup() {
            this.services.dialog.showModal((dialogHandler) =>
                <PanicButtonPopupComponent
                    textMessage1={this.services.translation.translate('panic_restriction_popup_message1')}
                    textMessage2={this.services.translation.translate('panic_restriction_popup_message2')}
                    textMessage3={this.services.translation.translate('panic_restriction_popup_message3')}
                    dialogHandler={dialogHandler}
                />,
                {
                    title: this.services.translation.translate("panic_restriction_popup_title"),
                    shouldBeClosedOnlyByUser: true,
                    hideCloseButton: true,
                    isHighPriority: true
                })
        }

        private _onMouseEnterPanicBtn() {
                if(!this.services.device.os.isMobileOS){
                    this.setState({isTooltipVisible: true});
                    this._sendAnalytics("click");
                }
        }

        private _onMouseLeavePanicBtn() {
            if(!this.services.device.os.isMobileOS) {
                this.setState({isTooltipVisible: false});
            }
        }

    private _closeToolTip(event) {
        event.stopPropagation();
        this.setState({isTooltipVisible: false});
    }

        private onClickPanicBtn() {
            if (!this.state.isTooltipVisible) {
                this.setState({isTooltipVisible: true});
                this._sendAnalytics("click");
            }
        }

        private _sendAnalytics(label: string) {
            this.services.analytics.sendOrbitUserFlowEvent("Navigation", "Header", "Icon_panic_" + label);
        }

        private _renderCloseBtn() {
            if (!this.services.mediaQuery.hover) {
                return <PanicButtonTooltipCloseBox className={'cy-tooltip-close'}
                    onClick={(event) => this._closeToolTip(event)} />
            }
            return null;
        }

    private _renderTooltipClickHere() {
        if (this.services.mediaQuery.sAndBelow && this.services.mediaQuery.portrait) {
            return (<div>{this._getTooltipBox()}</div>);
        } else {
            return this._getTooltipBox();
        }
    }

        private _getTooltipBox() {
            return <TooltipClickHereBox className={CyClass('cy-tooltip-click-here')}
                onClick={() => this._restrictUser()}>klicken Sie hier.</TooltipClickHereBox>
        }

        private _renderMobileOverlay() {
            if (this.services.device.os.isMobileOS) {
                return <PanicButtonMobileOverlayBox className={classNames(CyClass('cy-tooltip-box'), {
                    [ACTIVE]: this.state.isTooltipVisible
                })}
                    onClick={(event) => this._closeToolTip(event)} />
            }
            return null;
        }

        render() {
            return (
                <React.Fragment>
                    <PanicButtonBox className={classNames(CyClass('cy-panic-button-germany'), {
                        [ACTIVE]: this.state.isTooltipVisible,
                    })}
                        onMouseEnter={() => this._onMouseEnterPanicBtn()}
                        onMouseLeave={() => this._onMouseLeavePanicBtn()}
                        onClick={() => this.onClickPanicBtn()}>
                        <Image src={this.services.theme.currentTheme.images.germanyPanicButton.toString()} />
                        <PanicButtonTooltipBox
                            className={classNames(CyClass('cy-tooltip-box'), {
                                [ACTIVE]: this.state.isTooltipVisible,
                                [IN_DETAILED_HISTORY]: (this.props.placement === GermanyResponsibleGamingButtonPlacement.inDetailedHistory)
                            })}>
                            <div>
                                Um eine 24-stündige Spielpause einzulegen,
                                {this._renderTooltipClickHere()}
                                {this._renderCloseBtn()}
                            </div>
                        </PanicButtonTooltipBox>
                    </PanicButtonBox>
                    {this._renderMobileOverlay()}
                </React.Fragment>
            )
        }
    };